import { __decorate, __extends } from "tslib";
import { Editor } from '@tinymce/tinymce-react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { createModel, updateModel } from '../../api/models';
import { list as productList } from '../../api/products';
import { ModelColor, ModelType } from '../../models/Model';
import { Button } from '../../components/Button';
import { Dropdown } from '../../components/Dropdown';
import { Modal } from '../../components/Modal';
import { ProductIdGroup } from '../../components/ProductIdGroup';
import { PlusIcon } from '../../icons/PlusIcon';
import { getEditorKey, getEditorOptions, isHtmlEmpty } from '../../utils/utils';
import S from './models.styl';
var ModelsDetailsModal = /** @class */ (function (_super) {
    __extends(ModelsDetailsModal, _super);
    function ModelsDetailsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            titleInputError: false,
            contentInputError: false,
            colorInputError: false,
            typeInputError: false,
            linkedProductError: false,
            editorState: '',
            colors: [ModelColor.black, ModelColor.red, ModelColor.yellow, ModelColor.infected],
            types: [ModelType.dry, ModelType.damp, ModelType.wet],
            products: [],
        };
        _this.removeCount = 10;
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'title') {
                _this.setState({ titleInputError: false });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.onClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.onColorChange = function (color) {
            _this.setState({
                selectedColor: color,
            });
        };
        _this.onTypeChange = function (type) {
            _this.setState({
                selectedType: type,
            });
        };
        _this.onAddCombination = function () {
            var combinations = _this.state.linkedProductIds || [];
            if (combinations.length !== 0) {
                if (combinations[combinations.length - 1].length !== 0) {
                    combinations.push([]);
                    _this.setState({
                        linkedProductIds: combinations,
                    });
                }
            }
        };
        _this.onRemoveGroup = function (index) {
            var combinations = _this.state.linkedProductIds || [];
            combinations.splice(index, 1);
            _this.removeCount += 10;
            _this.setState({
                linkedProductIds: combinations,
            });
        };
        _this.onProductGroupChanged = function (index, group) {
            var combinations = _this.state.linkedProductIds || [];
            combinations[index] = group;
            _this.setState({
                linkedProductIds: combinations,
            });
        };
        return _this;
    }
    ModelsDetailsModal.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.model) {
            var model = this.props.model;
            this.setState({
                editorState: model.content || '',
                selectedType: model.type,
                selectedColor: model.color,
                linkedProductIds: (model === null || model === void 0 ? void 0 : model.linkedProductIds) || [[]],
            });
        }
        else {
            this.setState({
                linkedProductIds: [[]],
            });
        }
        productList().then(function (products) {
            _this.setState({
                products: (products === null || products === void 0 ? void 0 : products.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    ModelsDetailsModal.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var title = elements.title.value;
        if (title.length === 0) {
            this.setState({ titleInputError: true });
            valid = false;
        }
        var html = this.editorStateRef.getContent();
        if (isHtmlEmpty(html)) {
            this.setState({ contentInputError: true });
            valid = false;
        }
        var color = this.state.selectedColor;
        if (!color) {
            this.setState({ colorInputError: true });
            valid = false;
        }
        var type = this.state.selectedType;
        if (!type) {
            this.setState({ typeInputError: true });
            valid = false;
        }
        var ids = this.state.linkedProductIds;
        if (!ids || ids.length === 0) {
            this.setState({ linkedProductError: true });
            valid = false;
        }
        var flatList = '';
        ids === null || ids === void 0 ? void 0 : ids.forEach(function (group) {
            if (group.length !== 0) {
                if (group.length === 1 && group[0] === -10) {
                    // Do not add group with only the infected id selected
                }
                else {
                    if (flatList.length !== 0) {
                        flatList = flatList + ";";
                    }
                    flatList += group.join(',');
                }
            }
        });
        if (!valid) {
            return;
        }
        var request = {
            title: title,
            content: html,
            color: this.state.selectedColor || ModelColor.black,
            type: this.state.selectedType || ModelType.dry,
            linkedProductIds: flatList,
        };
        this.setState({ loading: true });
        if (this.props.model) {
            request.id = this.props.model.id;
            updateModel(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
        else {
            createModel(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
    };
    ModelsDetailsModal.prototype.getTypeText = function (type) {
        var i18n = this.props.store.i18n;
        if (type === ModelType.dry) {
            return i18n.dry;
        }
        else if (type === ModelType.damp) {
            return i18n.damp;
        }
        else {
            return i18n.wet;
        }
    };
    ModelsDetailsModal.prototype.getColorText = function (color) {
        var i18n = this.props.store.i18n;
        if (color === ModelColor.black) {
            return i18n.black;
        }
        else if (color === ModelColor.red) {
            return i18n.red;
        }
        else if (color === ModelColor.yellow) {
            return i18n.yellow;
        }
        else {
            return i18n.infected;
        }
    };
    ModelsDetailsModal.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this, props = _b.props, state = _b.state;
        var i18n = props.store.i18n;
        var model = props.model;
        var loading = state.loading, editorState = state.editorState;
        return (React.createElement(Modal, { className: props.className, onRequestClose: props.onClose },
            React.createElement("div", { className: S.modelsAddView },
                React.createElement("p", { className: S.modelsHeaderText }, model ?
                    i18n.modelsUpdateTitle
                    :
                        i18n.modelsCreateTitle),
                React.createElement("form", { className: "" + S.detailsDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                    React.createElement("div", null,
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePlaceholder),
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.inputTitlePlaceholder),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "title", autoComplete: "title", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: model === null || model === void 0 ? void 0 : model.title })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.titleInputError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleColor),
                        React.createElement(Dropdown, { maxHeight: 190, isFixed: true, className: "modalDropDown", boxClass: "modalDropDownBox", label: "" + (state.selectedColor ? this.getColorText(state.selectedColor) : i18n.inputChoose) },
                            React.createElement(Dropdown.List, null, this.state.colors.map(function (color, index) { return (React.createElement(Dropdown.Item, { key: index, data: "colorItem", autoClose: true, onClick: function (_) { return _this.onColorChange(color); } }, _this.getColorText(color))); }))),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.colorInputError ? 'inputErrorActive' : '') }, i18n.validationSelectError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleType),
                        React.createElement(Dropdown, { maxHeight: 190, isFixed: true, className: "modalDropDown", boxClass: "modalDropDownBox", label: "" + (state.selectedType ? this.getTypeText(state.selectedType) : i18n.inputChoose) },
                            React.createElement(Dropdown.List, null, this.state.types.map(function (type, index) { return (React.createElement(Dropdown.Item, { key: index, data: "typeItem", autoClose: true, onClick: function (_) { return _this.onTypeChange(type); } }, _this.getTypeText(type))); }))),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.typeInputError ? 'inputErrorActive' : '') }, i18n.validationSelectError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleContent),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.editorStateRef = editor; }, apiKey: getEditorKey(), initialValue: editorState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.contentInputError ? 'inputErrorActive' : '') }, i18n.validationContentError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputProductCombinations),
                        React.createElement("div", { className: S.modelCombination }, state.products &&
                            React.createElement(React.Fragment, null, (_a = this.state.linkedProductIds) === null || _a === void 0 ? void 0 : _a.map(function (productIds, index) { return (React.createElement(ProductIdGroup, { key: index * _this.removeCount, index: index, productIds: productIds, products: state.products || [], onRemoveGroup: _this.onRemoveGroup, onProductGroupChanged: _this.onProductGroupChanged })); }))),
                        React.createElement("div", { className: S.modelAddButtonWrapper },
                            React.createElement(Button, { className: "" + S.modelAddButton, type: "button", onClick: this.onAddCombination },
                                React.createElement(PlusIcon, null),
                                " ",
                                i18n.inputAddCombination)),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.linkedProductError ? 'inputErrorActive' : '') }, i18n.validationSelectError)),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.modelsModalButton, type: "submit", spinner: loading }, model ?
                        i18n.actionUpdate
                        :
                            i18n.actionCreate),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.modelsModalButton + " " + S.modelsModalCancel, type: "button", spinner: loading, onClick: this.onClose }, i18n.alertModalCancel)))));
    };
    __decorate([
        action.bound
    ], ModelsDetailsModal.prototype, "onSubmit", null);
    ModelsDetailsModal = __decorate([
        inject('store'),
        observer
    ], ModelsDetailsModal);
    return ModelsDetailsModal;
}(React.Component));
export { ModelsDetailsModal };
